import type { GridState } from '@cmg/data-grid';
import { getColDefId } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../graphql';
import { statusColDef } from '../../columns/status';

export const INITIAL_INVESTOR_FIRMS_GRID_STATE: GridState = {
  filter: {
    filterModel: {
      [getColDefId(statusColDef)]: {
        values: [RolodexRecordStatus.Effective],
        filterType: 'set',
      },
    },
  },
};
